import { PanelParameters } from '../types/types';
import Box, { BoxProps } from '@mui/material/Box';
import Accordion, {AccordionProps} from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
// import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDown from '@syte-tech/ui/icons/ArrowDown';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import InputAdornment from '@mui/material/InputAdornment';

const PanelParameterControls: React.FC<AccordionProps & { parameters: PanelParameters, onParametersChange: (newValue: PanelParameters) => void }> = ({ parameters, onParametersChange, ...props }) => {

  function updateValue<K extends keyof PanelParameters>(key: K, newValue: PanelParameters[K]) {
    onParametersChange({
      ...parameters,
      [key]: newValue
    }); 
  };

  return (
    <Accordion {...props}>
      <AccordionSummary
        expandIcon={<ArrowDown />}>
        <Typography variant="body2" paddingBottom={3}>Modulparameter</Typography>
      </AccordionSummary>
      <AccordionDetails>
      <Stack direction="column" gap={2}>

        <TextField
          label="Modulbreite"
          type="number"
          value={parameters.width}
          onChange={(e) => updateValue('width', parseFloat(e.target.value))}
          slotProps={{
            htmlInput: { step: 0.1, min: 0.5, max: 3.0 },
            input: {
              endAdornment: <InputAdornment position="end">m</InputAdornment>,
            }
          }}
        />
        <TextField
          label="Modulhöhe"
          type="number"
          value={parameters.height}
          onChange={(e) => updateValue('height', parseFloat(e.target.value))}
          slotProps={{
            htmlInput: { step: 0.1, min: 0.5, max: 3.0 },
            input: {
              endAdornment: <InputAdornment position="end">m</InputAdornment>,
            }
          }}
        />
        <TextField
          label="Modulwirkungsgrad"
          type="number"
          value={parameters.efficiency * 100}
          onChange={(e) => updateValue('efficiency', parseFloat(e.target.value) / 100)}
          slotProps={{
            htmlInput: { step: 1, min: 10, max: 100 },
            input: {
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }
          }}
        />
        <Typography variant="body2">entspricht {(parameters.width * parameters.height * parameters.efficiency * 1000).toFixed()} Wp Modul-Nennleistung</Typography>
        <TextField
          label="Aufständerung auf"
          type="number"
          value={parameters.min_tilt}
          onChange={(e) => updateValue('min_tilt', parseFloat(e.target.value))}
          slotProps={{
            htmlInput: { step: 5, min: 0, max: 90 },
            input: {
              endAdornment: <InputAdornment position="end">°</InputAdornment>,
            }
          }}
        />
      </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default PanelParameterControls;